<template>  
  <div class="pintuanorderdetail">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{orderDetail.Fstatus}}</p>
    </div>
    <router-link :to="'/usercenter/pintuanorderdelivery?orderNo='+orderDetail.Fid" class="" v-if="orderDetail.Fdelivery == 1&& orderDetail.DeliveryTracking && orderDetail.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ orderDetail.DeliveryTracking[0].WuLiu.data.length>0?orderDetail.DeliveryTracking[0].WuLiu.data[0].context : orderDetail.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    <div class="order-delivery" v-if="!loaded">
      <div class="mapIcon">
            <img src="/static/icon/address-location.png" />
          </div>
      <div class="delivery-info">
        <div class="member-info">
          <p class="username">{{orderDetail.FreceivName}}</p>
          <p class="mobile">{{orderDetail.FreceivTel}}</p>
        </div>
        <div class="address">{{orderDetail.FreceivAddress}}</div>
      </div>
    </div>

    <div class="invite" v-if="orderDetail.FjoinGroup">
      <div class="inviteTitle">
        <span>参团人员</span>
      </div>
      <!-- <p class="inviteCount">再邀请 <span style="color: red;">2</span> 人拼单成功</p> -->
      <!-- <div class="inviteImg">
        <template v-for="joinItem in orderDetail.FjoinGroup">        
          <div class="clonel">
            <img :src="joinItem.Fminnerbm" alt="">
            <template v-if="joinItem.FisColonel == '1'">   
              <p class="tuanzhang">团长</p> 
            </template>
            <mu-icon value=":fa fa-mycicle1" style="color:#ccc;" :size="50" v-for="i in parseInt(pintuanInfo.FremainingNum)" :key="i" />
            
          </div>
        </template>
      </div> -->
      <div class="inviteImg">
         <div class="clonel" v-for="joinItem in orderDetail.FjoinGroup" :key="joinItem">
           <img :src="joinItem.Fminnerbm" alt="">
           <p class="tuanzhang" v-if="joinItem.FisColonel == '1'">团长</p>
         </div>
         <template v-for="i in orderDetail.FgroupNumber-orderDetail.FjoinGroup.length" >
         <mu-icon value=":fa fa-mycicle1" style="color:#ccc;" :size="50" :key="i" />
         </template>
      </div>
      <mu-raised-button label="去分享" style="width:26px;line-height:26px;" v-if="orderDetail.Fstatus=='待分享' " :to="'/groupShop/groupShopShar?skuId='+orderDetail.Fsku+'&groupId='+orderDetail.Fgroupid" class="button-item" primary></mu-raised-button>
    </div>
    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <div class="shoptip">
          <img class="shop-logo" :src="orderDetail.ShopLogo" />
          <p class="shop-name">{{orderDetail.ShopName}}</p>
          <p class="state"></p>
        </div>
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in orderDetail.Fsuborder" :key="orderItem.Fid">              
              <router-link :to="'/retail/productDetail?skuId='+orderItem.FskuId+'&activityId='+ orderDetail.Factivityid">
                <img :src="orderItem.FproductImage?orderItem.FproductImage:IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
              </router-link> 
              <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">                      
                <router-link :to="'/retail/productDetail?skuId='+orderItem.FskuId+'&activityId='+ orderDetail.Factivityid">
                  <p class="product-name">{{orderItem.FproductName}}</p>
                </router-link>
                <p class="attr">数量:{{orderItem.Fquantity}}</p>
                <p class="state">{{orderDetail.Fstatus}}</p>
                <p class="price"><i class="fa fa-rmb"></i>{{orderItem.FproductPrice}}</p>
                <div ><router-link class="item-button sellservice-request" :to="'/usercenter/sellservicerequest?orderType=2&sellServiceType=3&itemId=' +orderDetail.Fid" v-if="orderDetail.SellServiceType==3 && orderItem.Fis7==1">申请退款</router-link></div>
                <router-link class="item-button sellservice-request" :to="'/usercenter/sellservicerequest?orderType=2&sellServiceType=1&itemId='+orderDetail.Fid" v-if="orderDetail.SellServiceType==1 && orderItem.Fis7==1">申请退货</router-link>
                <router-link class="item-button" :to="'/usercenter/pintuanOrderEvaluate?orderNumber='+orderDetail.ForderNumber+'&itemId='+orderItem.Fid+'&skuId='+orderItem.FskuId" v-if="orderDetail.Fstatus=='已完成'&&orderDetail.FisComment=='未评价'">评价</router-link>
              </div>
            </div>
          </div>
        </div>
          <div class="order-detail" v-if="!loaded">
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
              <div class="field"><span>订单编号：</span>{{orderDetail.ForderNumber}}</div>
              <div class="field"><span>下单时间：</span>{{orderDetail.ForderTime}}</div>
              <div class="field payOverDate" v-if="orderDetail.Fstatus =='待付款'"><span>超时时间：</span><span class="payOverDateTime">{{payOverDateName}}</span></div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>支付方式：</span>{{orderDetail.FpaymentType}}</div>
            <div class="field"><span>支付时间：</span>{{orderDetail.FpayTime}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field" ><span>配送方式：</span>{{orderDetail.FdeliveryName}}</div>
            <div class="field"><span>期望配送日期：</span>{{ orderDetail.FdeliveryPeriodName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field" v-if="orderDetail.FbillName"><span>发票抬头：</span>{{orderDetail.FbillName}}</div>
            <div class="field" v-if="!orderDetail.FbillName"><span>发票抬头：</span>无</div>
            <div class="field" v-if="orderDetail.Fcomment"><span>留言：</span>{{orderDetail.Fcomment}}</div>
          </div>
        </div>
      </div>
    </div>
    
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.Fprice}}</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.Fpostage}}</span>
        </div>
        <!-- <div class="field">
          <span class="title">已使用BAW</span>
          <span class="num">{{orderDetail.OrderMoney.DiscountMoney.toFixed(6)}}BAW</span>
        </div> -->
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.Fpayable}}</span>
        </div>
      </div>
    </div>
    <div class="operator" v-if="!loaded && (orderDetail.Fstatus == '待付款' || orderDetail.Fstatus=='待收货' || orderDetail.Fstatus=='售后待审核')">
      <div class="button-list">
        <mu-raised-button label="取消订单" @click="orderCancel(orderDetail.ForderNumber)" class="orderBtn receive" v-if="orderDetail.Fstatus == '待付款' "></mu-raised-button>
        <router-link :to="'/groupShop/orderPay?Fid='+orderDetail.Fid+'&orderNumber='+ orderDetail.ForderNumber" v-if="orderDetail.Fstatus == '待付款' && isCanPay">
          <mu-raised-button label="付款" class="button-item gobuy" primary></mu-raised-button>
        </router-link>
        <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -- -->
        <mu-raised-button label="确认收货" class="button-item" @click="orderConfrim" primary v-if="orderDetail.Fstatus=='待收货' || (orderDetail.Fstatus=='售后待审核' && orderDetail.Status=='待收货')"></mu-raised-button>
      </div>
    </div>    
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      orderDetail:{},
      totalSpan : 0,
      payOverDateName:'',
      isCanPay:false,
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()    
  },
  methods: { 
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getOrderDetail(){
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapOrderGetInfoById",
        JSON.stringify({id: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.orderDetail = res.Data
          ths.$refs.XRtoast.hide()
          if(res.Data.Fstatus == '待付款'){
            ths.calcPayOverDate(ths.orderDetail.FremainingTime)
          }          
        }
      });
    },
    calcPayOverDate(tmpTime){   
      var ths = this

      var hour = tmpTime.split(':')[0];
      var min = tmpTime.split(':')[1];
      var sec = tmpTime.split(':')[2];
      ths.totalSpan = Number(hour*3600) + Number(min*60) + Number(sec);
      
      var interval = setInterval(function(){
        ths.totalSpan = ths.totalSpan-1    
        if (ths.totalSpan <= 0) {
          ths.isCanPay = false
          ths.payOverDateName='已超时'
          clearInterval(interval);
          return;
        }else{
          ths.isCanPay = true
        }
        var hh = parseInt(ths.totalSpan  / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ths.totalSpan  / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ths.totalSpan  % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }

        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒' 
      },1000)
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/PinTuanServer/WapReceivingGoods",
        JSON.stringify({orderNumber: this.orderDetail.ForderNumber, userType:1})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },
    orderItemConfrim(itemId){
      
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/OrderItemConfrim",
        JSON.stringify({orderItemNos: [itemId]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
          
        }
      });
    },
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/PintuanServer/orderCancel",
        JSON.stringify({orderNumber: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderDetail()
          })
        }
      });
    },
  }
}
</script>

<style>
#app .pintuanorderdetail{
  background: #eee;
  bottom:unset;
  padding-bottom: 56px;
}
.pintuanorderdetail .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}

.pintuanorderdetail .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
  border-radius: 10px;
}
.pintuanorderdetail .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.pintuanorderdetail .delivery .leftIcon {
  float:left;
}
.pintuanorderdetail .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.pintuanorderdetail .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.pintuanorderdetail .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.pintuanorderdetail .order-delivery {
  overflow: hidden;
  background: white;
  padding:10px;
  margin-top: 10px;
  border-radius: 10px;
}
.pintuanorderdetail .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.pintuanorderdetail .order-delivery .delivery-info{
  overflow: hidden;
}
.pintuanorderdetail .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.pintuanorderdetail .order-delivery .member-info .username{
  float: left;
}
.pintuanorderdetail .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.pintuanorderdetail .order-delivery .address{
  font-size: 12px;
  color:#999;
}
.pintuanorderdetail .hidden-scorll{background-color: #FCFCFC;}
.pintuanorderdetail .order-list{
  overflow: hidden;
}
.pintuanorderdetail .order-item{
  background: white;
  margin: 10px 0 0;
  border-radius: 10px;
}
.pintuanorderdetail .shoptip{
  overflow: hidden;
  background: white;
  border-radius: 10px;
  padding:0 10px;
}
.pintuanorderdetail .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.pintuanorderdetail .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.pintuanorderdetail .shoptip .state{
  float: right;
  line-height: 48px;
}

.pintuanorderdetail .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.pintuanorderdetail .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.pintuanorderdetail .suborder-item ~ .suborder-item{
  border-top:1px solid #eee;
}
.pintuanorderdetail .suborder-item .order-img{
  width: 75px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
  height: 75px;
  object-fit: cover;
}
.pintuanorderdetail .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 95px;
}
.pintuanorderdetail .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.pintuanorderdetail .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.pintuanorderdetail .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.pintuanorderdetail .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.pintuanorderdetail .suborder-item .product-info .state{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 14px;
  color:red;
}
.pintuanorderdetail .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 10px;
  float: left;
}
.pintuanorderdetail .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 8px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.pintuanorderdetail .order-total{
  overflow: hidden;
  border-bottom:1px solid #eee;
}
.pintuanorderdetail .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.pintuanorderdetail .total-text span{
  font-size: 14px;
}

.pintuanorderdetail .order-detail{
  margin: 10px 0;
  background: white;
  border-radius: 10px;
}
.pintuanorderdetail .order-info {
  padding: 10px 0;
}
.pintuanorderdetail .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  color:#999;
}
.pintuanorderdetail .order-info .field span{
  color: #4D4A49;
}
.pintuanorderdetail .order-info .field .title{
  float: left;
}
.pintuanorderdetail .order-info .field .num{
  float: right;
  font-size: 14px;
}
.pintuanorderdetail .order-info .field .payOverDateTime{
  color:red;
}
.pintuanorderdetail .order-info .fa{
  font-size: 12px;
}
.pintuanorderdetail .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.pintuanorderdetail .order-info .summary .num{
  color:red;
}


.pintuanorderdetail .order-operator{
  overflow: hidden;
}
.pintuanorderdetail .order-operator .button-list{
  float: right;
  padding: 10px 10px;
  height: 57px;
}

.pintuanorderdetail .operator{  
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.pintuanorderdetail .operator .button-list{
  height: 57px;
  float: right;
}


  .pintuanorderdetail .invite{
    padding: 0 16px;
    margin-top: 10px;
    background: #fff;
    border-radius: 10px;
    text-align: right;
  }
  .pintuanorderdetail .mu-raised-button.mu-raised-button-inverse{height: 35px;background-color: red;}
  .pintuanorderdetail .invite .mu-raised-button{
    background: red;
  }
  .pintuanorderdetail .invite .inviteTitle{
    font-size: 14px;
    text-align: left;
  }
  .pintuanorderdetail .invite .inviteCount{
    font-size: 16px;
  }
  .pintuanorderdetail .invite .inviteImg{
    margin-top: 10px;
    text-align: left;
  }
  .pintuanorderdetail .invite .inviteImg .clonel{
    width: 44px;
    height: 44px;
    border: 1px solid #FAC424;
    position: relative;
    display: inline-block;
    text-align: center;
    margin-right: 4px;
    border-radius: 50%;
  }
  .pintuanorderdetail .invite .inviteImg .clonel img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  
  .pintuanorderdetail .invite .inviteImg .tuanzhang{
    position: absolute;
    left: -5px;
    top: -5px;
    color: #CA8F10;
    background: #FAC424;
    border-radius: 10px 10px;
    padding: 0 3px;
    font-size: 12px;
  }
  .pintuanorderdetail .invite_botton{
    background: #AD0E11;
    width: 100%;
    height: 45px;
    margin-top: 25px;
  }
  .pintuanorderdetail .invite_botton .mu-raised-button-label{
    font-size: 16px;
  }
  .pintuanorderdetail .inviteTime{
    color: #999;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
  }
.pintuanorderdetail .operator .button-list .button-item{
  margin: 10px;
  height:35px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/pintuanOrderdetail.vue